/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_physio': {
    width: 32,
    height: 29,
    viewBox: '0 0 32 29',
    data: '<path pid="0" d="M19 28.5a1.5 1.5 0 0 0 0-3h-8M29 15l-3.307-4.777A4 4 0 0 0 22.404 8.5h-5.386a3 3 0 0 0-2.962 3.474L15.5 21m10-6l-2-2.5V15m-8.64 2l5.335 2.41a1.37 1.37 0 1 0 1.177-2.474L17.5 15l-.5-3m6 4.5h5a1.5 1.5 0 0 1 0 3h-4.5L22 25l8 .5a1.5 1.5 0 0 1 0 3H10.5a3 3 0 1 1 0-6h8l1-2m-13 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm16-20a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" stroke-miterlimit="2.366"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_physio.js